import moment from "moment";
const currentDate = moment().format("YYYY-MM-DD");
const getDefaultAvailabilityState = () => {
  return {
    weekdays: {
      Monday: {
        timespans: [],
        status: "Closed"
      },
      Tuesday: {
        timespans: [],
        status: "Closed"
      },
      Wednesday: {
        timespans: [],
        status: "Closed"
      },
      Thursday: {
        timespans: [],
        status: "Closed"
      },
      Friday: {
        timespans: [],
        status: "Closed"
      },
      Saturday: {
        timespans: [],
        status: "Closed"
      },
      Sunday: {
        timespans: [],
        status: "Closed"
      }
    },
    holidays: {
      NewYearsDay: {
        timespans: [],
        status: "Unspecified"
      },
      PalmSunday: {
        timespans: [],
        status: "Unspecified"
      },
      HolyThursday: {
        timespans: [],
        status: "Unspecified"
      },
      GoodFriday: {
        timespans: [],
        status: "Unspecified"
      },
      EasterDay: {
        timespans: [],
        status: "Unspecified"
      },
      EasterMonday: {
        timespans: [],
        status: "Unspecified"
      },
      FirstOfMay: {
        timespans: [],
        status: "Unspecified"
      },
      AscensionDay: {
        timespans: [],
        status: "Unspecified"
      },
      FridayAfterAscensionDay: {
        timespans: [],
        status: "Unspecified"
      },
      WhitSunday: {
        timespans: [],
        status: "Unspecified"
      },
      WhitMonday: {
        timespans: [],
        status: "Unspecified"
      },
      ConstitutionDay: {
        timespans: [],
        status: "Unspecified"
      },
      ChristmasEve: {
        timespans: [],
        status: "Unspecified"
      },
      ChristmasDay: {
        timespans: [],
        status: "Unspecified"
      },
      BoxingDay: {
        timespans: [],
        status: "Unspecified"
      },
      NewYearsEve: {
        timespans: [],
        status: "Unspecified"
      }
    },
    special: [],
    closed: [],
    availability: "OpeningHours"
  };
};

const initialState = {
  all: getDefaultAvailabilityState(),
  defaultAvailability: getDefaultAvailabilityState(),
  defaultTimeSpan: {
    begin: "00:00",
    end: "00:00"
  },
  defaultClosed: {
    begin: currentDate,
    end: currentDate
  },
  defaultSpecial: {
    Monday: {
      timespans: [],
      status: "Closed",
      begin: currentDate,
      end: currentDate
    },
    Tuesday: {
      timespans: [],
      status: "Closed",
      begin: currentDate,
      end: currentDate
    },
    Wednesday: {
      timespans: [],
      status: "Closed",
      begin: currentDate,
      end: currentDate
    },
    Thursday: {
      timespans: [],
      status: "Closed",
      begin: currentDate,
      end: currentDate
    },
    Friday: {
      timespans: [],
      status: "Closed",
      begin: currentDate,
      end: currentDate
    },
    Saturday: {
      timespans: [],
      status: "Closed",
      begin: currentDate,
      end: currentDate
    },
    Sunday: {
      timespans: [],
      status: "Closed",
      begin: currentDate,
      end: currentDate
    }
  }
};
const state = Object.assign({}, initialState);

export const availability = {
  namespaced: true,
  state: state,
  getters: {
    defaultAvailability: state => state.defaultAvailability
  },
  actions: {
    setAvailabilityStateToInitial({ commit }) {
      commit("setAvailabilityStateToInitial");
    },
    setAvailabilityStateToDefault({ commit }) {
      commit("setAvailabilityStateToDefault");
    },
    setAvailabilityOnly({ commit }) {
      commit("setAvailabilityOnly");
    }
  },
  mutations: {
    setAvailabilityStateToInitial(state) {
      const initial = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.state.aed.all.availability))
      );

      Object.assign(state.all, initial);
    },
    setAvailabilityStateToDefault(state) {
      const defaultTimes = Object.assign(
        {},
        JSON.parse(JSON.stringify(state.defaultAvailability))
      );
      state.all = defaultTimes;
    },
    setAvailabilityOnly(state) {
      delete state.all.weekdays;
      delete state.all.holidays;
      delete state.all.special;
      delete state.all.closed;
    },
    resetState(state) {
      for (let prop in state) {
        state[prop] = initialState[prop];
      }
    }
  }
};
